import React from "react";
import { withNamespaces } from "react-i18next";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const AlertMaterial = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const AlertsComponent = ({
  openExport,
  handleCloseExport,
  messageTranslated,
  openExportError,
  handleCloseExportError,
  showToast,
  handleCloseShowToast,
  handleCloseShowToastMSG,
  toastText,
  showToastMSG,
  t
}) => {
  const toastResultMSG = (text) => {
    const severity = text === "error" ? "error" : "success";
    const message =
      text === "error"
        ? t("portalrh.workDays.error")
        : t("portalrh.workDays.success");

    return (
      <AlertMaterial
        onClose={handleCloseShowToastMSG}
        severity={severity}
        sx={{ width: "100%" }}
      >
        {message}
      </AlertMaterial>
    );
  };

  return (
    <>
      <Snackbar
        open={openExport}
        autoHideDuration={5000}
        onClose={handleCloseExport}
      >
        <AlertMaterial
          onClose={handleCloseExport}
          severity="success"
          sx={{ width: "100%" }}
        >
          {messageTranslated}
        </AlertMaterial>
      </Snackbar>
      <Snackbar
        open={openExportError}
        autoHideDuration={5000}
        onClose={handleCloseExportError}
      >
        <AlertMaterial
          onClose={handleCloseExportError}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("portalrh.workDays.export.dateToExport")}
        </AlertMaterial>
      </Snackbar>
      <Snackbar
        open={showToast}
        autoHideDuration={20000}
        onClose={handleCloseShowToast}
      >
        <AlertMaterial
          onClose={handleCloseShowToastMSG}
          severity="error"
          sx={{ width: "100%" }}
        >
          {toastText}
        </AlertMaterial>
      </Snackbar>
      <Snackbar
        open={showToastMSG}
        autoHideDuration={20000}
        onClose={handleCloseShowToastMSG}
      >
        {toastResultMSG(toastText)}
      </Snackbar>
    </>
  );
};

export default withNamespaces()(AlertsComponent);
